var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNext = function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 15.5,
    transform: "matrix(-1 0 0 1 16 16)",
    stroke: "#9BA0A5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.667 16-4-3.464v6.928l4-3.464Z",
    fill: "#9BA0A5"
  })));
};
export { SvgNext as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSByPSIxNS41IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAxNiAxNikiIHN0cm9rZT0iIzlCQTBBNSIvPgo8cGF0aCBkPSJNMTguNjY3IDE2TDE0LjY2NyAxMi41MzU5TDE0LjY2NyAxOS40NjQxTDE4LjY2NyAxNloiIGZpbGw9IiM5QkEwQTUiLz4KPC9zdmc+Cg==";